<div class="h-100 d-flex justify-content-around align-items-center gap-0_8">
  <i class="cp icon-comment fs-4" (click)="onClick('comment')" tooltip="Comment">
    @if (currentRow().comment?.length > 0) {
      <span class="icon-wrapper">
        <i class="fas fa-circle top-right-icon"></i>
      </span>
    }
  </i>
</div>
